import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ManageShiftsPageRoutingModule } from './manage-shifts-routing.module';
import { ManageShiftsPage } from './manage-shifts.page';
import { BhContentSearchComponentModule } from 'src/app/components/_core/bh-content-search/bh-content-search.component.module';
import { BhGridComponentModule } from 'src/app/components/_core/bh-grid/bh-grid.component.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManageShiftsPageRoutingModule,
    BhContentSearchComponentModule,
    BhGridComponentModule
  ],
  declarations: [ManageShiftsPage]
})
export class ManageShiftsPageModule {}
